import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var SpeakerFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5 2.528v39.783c0 .4-.2.7-.6.9-.3.2-.8.1-1.1-.1L8.4 32.115H1c-.5 0-1-.4-1-1V13.724c0-.5.4-1 1-1h7.5L21.9 1.729c.3-.2.7-.3 1.1-.1.3.2.5.5.5.9ZM27.6 5.927c.1-.5.6-.9 1.1-.9 8.6 1.1 15.3 8.496 15.3 17.392 0 8.897-6.7 16.293-15.3 17.293-.5.1-1-.3-1.1-.9-.1-.5.3-1 .9-1.1C36.1 36.814 42 30.317 42 22.42c0-7.896-5.9-14.393-13.6-15.393-.5 0-.9-.5-.8-1.1Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4 13.423c.1-.5.6-.9 1.2-.8 4.5.9 8 4.999 8 9.796 0 4.698-3.3 8.697-7.7 9.696-.5.1-1.1-.2-1.2-.7-.1-.5.2-1.099.7-1.199 3.5-.8 6.2-3.998 6.2-7.797 0-3.898-2.7-7.096-6.4-7.796-.6-.1-.9-.7-.8-1.2Z"
  }));
});
SpeakerFill.displayName = 'SpeakerFill';
SpeakerFill.defaultProps = {
  'aria-label': 'SpeakerFill'
};
export default SpeakerFill;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/SpeakerFill.js
// module id = 3288
// module chunks = 11